import { render, staticRenderFns } from "./PretsProfessionnels.vue?vue&type=template&id=6d1253f0&"
import script from "./PretsProfessionnels.vue?vue&type=script&lang=js&"
export * from "./PretsProfessionnels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports